import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ standalone: false, name: "underscore" })
export class UnderscorePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return "";
    return value.replace(/_/g, " ");
  }
}
